/**
 * ecommerce-nav
 */

import $ from 'jquery';

// Module template
import './_ecommerce-nav.twig';

export const name = 'ecommerce-nav';

export const defaults = {
  dummyClass: 'js-ecommerce-nav-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Drupal Behaviors to handle initialization and reinitialization post-AJAX.
 */
Drupal.behaviors.ecommerceNav = {
  attach(context) {
    const $ecommerceNav = $('.main-nav__secondary--ecommerce', context).not(
      '.js-ecommerce-nav-initialized'
    );

    $ecommerceNav.addClass('js-ecommerce-nav-initialized');

    $ecommerceNav.on('click', '.ecommerce-nav__toggle', function (e) {
      e.preventDefault();
      $(this)
        .closest('.main-nav__secondary--ecommerce')
        .find('.ecommerce-nav')
        .toggleClass('nav-open');
    });
  },
};

export default Drupal.behaviors.ecommerceNav;
